import { GroupData, GroupMode, ResponseItem, RouteOrderByField } from '@bringg/types';

import { getGroupFilters, getLastGroup } from '../../shared/utils/grouping';
import { loaderPageCreator } from '../../shared/data/loader-page-creator';
import { orderExplorerRootStore } from 'bringg-web/features/monitoring/order-explorer/stores/order-explorer-root-store';
import { monitoringFiltersProvider } from '../../shared/components/monitoring-filter-bar/utils/monitoring-filter-provider';
import { orderExplorerLoader } from 'bringg-web/features/monitoring/order-explorer/data/order-explorer-loader';

async function load(group: GroupData, useCurrentFilters = true): Promise<ResponseItem[]> {
	const { orderExplorerStore } = orderExplorerRootStore.getStore();

	if (useCurrentFilters && orderExplorerStore.isGroupFullyLoaded(group)) {
		return getFlatItemsByGroupId(group);
	}

	const response = await orderExplorerLoader.load(
		{
			query_requests: [
				{
					grouping: orderExplorerStore.currentTableDefinition.groupMode,
					filters: {
						...monitoringFiltersProvider.mapFiltersToServer(
							orderExplorerStore.currentTableDefinition.filters.task
						),
						...getGroupFilters(group)
					},
					sorting: {
						key: 'id',
						direction: 'asc'
					},
					page: loaderPageCreator.create(
						orderExplorerStore.currentTableDefinition.groups,
						orderExplorerStore.currentTableDefinition.itemsByGroup,
						orderExplorerStore.currentTableDefinition.entityType,
						2500
					),
					collapsed_groups: [],
					entity_type: orderExplorerStore.currentTableDefinition.entityType,
					route_order_by_field: RouteOrderByField.StartTime
				}
			]
		},
		{ signal: orderExplorerStore.disposeSignal }
	);

	if (useCurrentFilters) {
		orderExplorerStore.setGroupsResponse(response, group.id);

		if (!orderExplorerStore.currentTableDefinition.itemsByGroup[group.id]) {
			await completeLastGroup();
		}
	}

	return getFlatItemsByGroupId(group);
}

async function completeLastGroup() {
	const currentTableDefinition = orderExplorerRootStore.getStore().orderExplorerStore.currentTableDefinition;

	if (
		[GroupMode.Team, GroupMode.None].includes(currentTableDefinition.groupMode) ||
		!currentTableDefinition.hasMoreData
	) {
		return;
	}

	return load(getLastGroup(currentTableDefinition.groups));
}

const getFlatItemsByGroupId = (group: GroupData): ResponseItem[] => {
	let itemsFromStore: ResponseItem[];
	const orderExplorerStore = orderExplorerRootStore.getStore().orderExplorerStore;

	if (group.groups?.length) {
		itemsFromStore = group.groups.reduce((items, innerGroup) => {
			items.push(...orderExplorerStore.currentTableDefinition.itemsByGroup[innerGroup.id]);
			return items;
		}, []);
	} else {
		itemsFromStore = orderExplorerStore.currentTableDefinition.itemsByGroup[group.id];
	}

	return itemsFromStore;
};

export const orderExplorerGroupLoader = { load, completeLastGroup };
